









import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from "vue-property-decorator"
import {ActiveInject} from "@/support/reactive"

/**
 * @status stable
 * @published 5.8.0
 * @changelog 5.8.0 Published.
 */
@Component
export default class JdsReactionOption extends Vue {

    @Prop() type!: string
    @Prop({type: Boolean, default: false}) active!: boolean

    @ActiveInject({from: 'jds.reaction-panel.bus'}) bus!: Vue

    emitClick() {
        if (this.bus) this.bus.$emit('close')
        this.$emit('click')
    }
}
